/* eslint "react-hooks/exhaustive-deps": "off" */
import React, { useState, useEffect, memo, useRef } from "react";
import { useTranslation } from "react-i18next";
import Graph from "@components/graphStatistics/Pie/Graphs";
import { customTooltips } from "@helpers/_functions";


export default memo(function Index({ employeesPerLanguages }) {
  const { t } = useTranslation("pages.employés.statistics");
  const chartRef = useRef(null);
  const [graphData, setGraphData] = useState({});

  useEffect(() => {
    let languageData = {};
    if (employeesPerLanguages?.length) {
      languageData = {
        datasets: [
          {
            data: employeesPerLanguages?.map((item) => item?.count) || [],
            backgroundColor:
              employeesPerLanguages?.map((item) => item?.backgroundColor) || [],
            hoverOffset: 4
          }
        ],
        labels: employeesPerLanguages.map(({name, count, percentValue }) => `${name} : ${count} (${percentValue}%)`) || [],
      };
    }
    setGraphData(languageData);
  }, [employeesPerLanguages]);

  const customOptions = {
    tooltips: {
      enabled:false,
      custom: (tooltip)=>customTooltips(tooltip,chartRef,t),
    },
  };
  const translatedLegends = employeesPerLanguages
    ?.map(({ name, backgroundColor }) => ({
      name: t(name),
      backgroundColor
    }))
    .sort(({ name: nameA }, { name: nameB }) =>
      nameA?.toLowerCase() < nameB?.toLowerCase() ? -1 : 1
    );
  return (
    <Graph
      graphData={graphData}
      legends={translatedLegends}
      title={t("Langues parlées")}
      spaceLegende="arh-space-y-2"
      customOptions={customOptions}
      chartRef={chartRef}
    />
  );
});
